module.exports = __webpack_public_path__ + "images/landing/landing-video-cover.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/landing-video-cover.jpg
// module id = CfwE
// module chunks = 51